// react
import React from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

// shared components
import DanishAddressRegisterAutocomplete from '@/components/datafordeler/DanishAddressRegisterAutocomplete';

const CreateBuildingDialog = ({
  open,
  onClose,
  handleCreateBuilding,
  account,
}) => {
  const { t } = useTranslation();
  const [formState, setFormState] = React.useState({
    Name: '',
    AccountId: 0,
    BaselineDayInterval: 10,
    BaselineDayOffset: 'PT12H',
    AllowSaturdayBaselineDay: true,
    Location: {
      Address: '',
      Latitude: null,
      Longitude: null,
    },
    UserInput: {
      CO2Coefficients: {
        Electricity: [],
        Heat: [],
        Gas: [],
      },
    },
  });

  const handleSubmit = () => {
    console.log('Submitting form with state:', formState);
    if (formState.Name && formState.Location.Address) {
      handleCreateBuilding(formState);
      onClose();
    }
  };

  const handleLocationSelect = (selection) => {
    const address = selection?.parsed?.tekst || '';

    const latitude = Number(selection?.details?.coordinates?.lat);
    const longitude = Number(selection?.details?.coordinates?.lon);

    const hasValidCoordinates =
      Number.isFinite(latitude) &&
      Number.isFinite(longitude) &&
      Math.abs(latitude) <= 90 &&
      Math.abs(longitude) <= 180;

    if (!address || !hasValidCoordinates) {
      console.error('CreateBuildingDialog: invalid location payload', {
        selection,
      });
      return;
    }

    setFormState((prev) => ({
      ...prev,
      Location: {
        Address: address,
        Latitude: latitude,
        Longitude: longitude,
      },
    }));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {t('actions.createItem', {
          item: t('items.building.indefinite', { ns: 'glossary' }),
        })}{' '}
        {account.Name ? `for ${account.Name}` : ''}
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          label="Navn"
          value={formState.Name}
          required
          error={!formState.Name}
          onChange={(e) =>
            setFormState((prev) => ({
              ...prev,
              Name: e.target.value,
            }))
          }
          fullWidth
          variant="filled"
          helperText="Provide a name for the building"
        />
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="caption" sx={{ display: 'block', mb: 0.5 }}>
              {t('building.address_compare.dar_label', {
                defaultValue: 'DAR (adressevaelger)',
              })}
            </Typography>
            <DanishAddressRegisterAutocomplete
              onAddressSelect={handleLocationSelect}
              value={formState?.Location?.Address || ''}
              autocompleteProps={{ disabled: false, fullWidth: true }}
              textFieldProps={{ size: 'small' }}
            />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            required
            type="number"
            name="BaselineDayInterval"
            label="Baseline Day Interval"
            size="small"
            fullWidth
            variant="filled"
            value={formState.BaselineDayInterval}
            helperText="Interval in days for baseline calculation"
            onChange={(e) =>
              setFormState((prev) => ({
                ...prev,
                BaselineDayInterval: e.target.value,
              }))
            }
          />
          <TextField
            required
            name="BaselineDayOffset"
            label="Baseline Day Offset"
            size="small"
            variant="filled"
            fullWidth
            value={formState.BaselineDayOffset}
            onChange={(e) =>
              setFormState((prev) => ({
                ...prev,
                BaselineDayOffset: e.target.value,
              }))
            }
            helperText="Offset in days for the baseline day calculation"
            // type="number"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose} color="primary">
          {t('actions.cancel')}
        </Button>
        <Button
          onClick={() => {
            // Handle form submission logic here
            handleSubmit();
            onClose();
          }}
          variant="contained"
        >
          {t('actions.create')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateBuildingDialog;
